/* Progressive A+ enlargement; original artwork and native image links stay intact. */
(() => {
  if (window.fwResponsiveMediaReady) return;
  window.fwResponsiveMediaReady = true;

  const artworkSelector = [
    '#pistazien-aplus > figure img',
    '#cashews-zimt-aplus > figure img',
    '#mandeln-aplus > figure img',
    '#bourbon-pekannuesse-aplus > figure img',
    '#bio-walnusskerne-aplus > figure img',
    '#getrocknete-aprikosen-aplus > figure img',
    '#nussmischung-aplus > figure img',
    '#pekannuss-karamell-aplus > figure img',
    '#cashews-geroestet-aplus > figure img',
    '.fw-story-image'
  ].join(',');
  const supportsDialog = typeof HTMLDialogElement !== 'undefined' &&
    typeof HTMLDialogElement.prototype.showModal === 'function';
  let dialog, frame, enlarged, loadState, zoomLabel, minus, plus, previousFocus;
  let scale = 1, imageWidth = 1464;

  function originalSource(source, originalLink) {
    return originalLink?.href || source.dataset.fwSrc || source.src;
  }

  function applyScale(nextScale) {
    const fitWidth = Math.min(frame.clientWidth, imageWidth);
    const maxScale = Math.max(1, Math.min(4, imageWidth / fitWidth));
    scale = Math.max(1, Math.min(nextScale, maxScale));
    enlarged.style.width = `${Math.round(fitWidth * scale)}px`;
    zoomLabel.textContent = `${Math.round(scale * 100)} %`;
    minus.disabled = scale <= 1;
    plus.disabled = scale >= maxScale;
  }

  function makeDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'fw-media-dialog';
    dialog.setAttribute('aria-label', (document.documentElement.lang.toLowerCase().startsWith('fr') ? "Présentation du produit agrandie" : (document.documentElement.lang.toLowerCase().startsWith('it') ? "Storia del prodotto ingrandita" : globalThis.fwExtraText("fw_extra.s_f92c2acbbf1e52", 'Vergrößerte Produktgeschichte'))));
    dialog.innerHTML = `
      <div class="fw-media-toolbar">
        <div class="fw-media-heading">
          <strong>${(document.documentElement.lang.toLowerCase().startsWith('fr') ? "Présentation du produit" : (document.documentElement.lang.toLowerCase().startsWith('it') ? "Storia del prodotto" : 'Produktgeschichte'))}</strong>
          <button type="button" data-fw-media-close autofocus>${(document.documentElement.lang.toLowerCase().startsWith('fr') ? "Fermer" : (document.documentElement.lang.toLowerCase().startsWith('it') ? "Chiudi" : globalThis.fwExtraText("fw_extra.s_b808f6e9707577", 'Schließen')))} <span aria-hidden="true">×</span></button>
        </div>
        <div class="fw-media-controls" aria-label="${(document.documentElement.lang.toLowerCase().startsWith('fr') ? "Taille de l’image" : (document.documentElement.lang.toLowerCase().startsWith('it') ? "Dimensioni dell’immagine" : globalThis.fwExtraText("fw_extra.s_101afdfffd9fb2", 'Bildgröße')))}">
          <button type="button" data-fw-media-minus aria-label="${(document.documentElement.lang.toLowerCase().startsWith('fr') ? "Réduire l’image" : (document.documentElement.lang.toLowerCase().startsWith('it') ? "Riduci l’immagine" : globalThis.fwExtraText("fw_extra.s_c0c03ab2e1c358", 'Bild verkleinern')))}">−</button>
          <output class="fw-media-zoom" aria-live="polite" aria-label="${(document.documentElement.lang.toLowerCase().startsWith('fr') ? "Agrandissement" : (document.documentElement.lang.toLowerCase().startsWith('it') ? "Ingrandimento" : globalThis.fwExtraText("fw_extra.s_62712850d25495", 'Vergrößerung')))}"></output>
          <button type="button" data-fw-media-plus aria-label="${(document.documentElement.lang.toLowerCase().startsWith('fr') ? "Agrandir davantage l’image" : (document.documentElement.lang.toLowerCase().startsWith('it') ? "Ingrandisci ancora l’immagine" : globalThis.fwExtraText("fw_extra.s_e5163109b3a4a9", 'Bild weiter vergrößern')))}">+</button>
          <button type="button" data-fw-media-fit>${(document.documentElement.lang.toLowerCase().startsWith('fr') ? "Ajuster" : (document.documentElement.lang.toLowerCase().startsWith('it') ? "Adatta" : 'Anpassen'))}</button>
        </div>
        <p>${(document.documentElement.lang.toLowerCase().startsWith('fr') ? "Agrandis pour lire. Fais glisser l’image ou utilise le défilement." : (document.documentElement.lang.toLowerCase().startsWith('it') ? "Ingrandisci per leggere. Scorri o trascina l’immagine." : globalThis.fwExtraText("fw_extra.s_0fae121e9480a4", 'Zum Lesen vergrößern. Im Bild wischen oder scrollen.')))}</p>
      </div>
      <div class="fw-media-frame" tabindex="0" role="region" aria-label="${(document.documentElement.lang.toLowerCase().startsWith('fr') ? "Vue de l’image ; déplacer avec les touches fléchées ou en faisant glisser" : (document.documentElement.lang.toLowerCase().startsWith('it') ? "Visualizzazione immagine; sposta con i tasti freccia o trascinando" : globalThis.fwExtraText("fw_extra.s_1015b7a0a936b6", 'Bildansicht, mit Pfeiltasten oder Wischen verschieben')))}">
        <p class="fw-media-load-state" role="status" hidden></p>
        <img class="fw-media-enlarged" alt="" decoding="async">
      </div>`;
    document.body.append(dialog);
    frame = dialog.querySelector('.fw-media-frame');
    enlarged = dialog.querySelector('.fw-media-enlarged');
    loadState = dialog.querySelector('.fw-media-load-state');
    enlarged.addEventListener('load', () => { loadState.hidden = true; });
    enlarged.addEventListener('error', () => {
      loadState.textContent = (document.documentElement.lang.toLowerCase().startsWith('fr') ? "Impossible de charger l’image. Ferme la vue et réessaie." : (document.documentElement.lang.toLowerCase().startsWith('it') ? "Impossibile caricare l’immagine. Chiudi la visualizzazione e riprova." : globalThis.fwExtraText("fw_extra.s_0a1c86f9b9e9d4", 'Das Bild konnte nicht geladen werden. Bitte schließe die Ansicht und versuche es erneut.')));
      loadState.hidden = false;
    });
    zoomLabel = dialog.querySelector('.fw-media-zoom');
    minus = dialog.querySelector('[data-fw-media-minus]');
    plus = dialog.querySelector('[data-fw-media-plus]');
    minus.addEventListener('click', () => applyScale(scale - 0.5));
    plus.addEventListener('click', () => applyScale(scale + 0.5));
    dialog.querySelector('[data-fw-media-fit]').addEventListener('click', () => applyScale(1));
    dialog.querySelector('[data-fw-media-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('fw-media-open');
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    });
    window.addEventListener('resize', () => {
      if (dialog.open) applyScale(scale);
    });
  }

  function openArtwork(event, source, originalLink) {
    if (!supportsDialog || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    window.fwDeferredImages?.load?.(source);
    if (!dialog) makeDialog();
    previousFocus = event.currentTarget;
    imageWidth = Math.max(source.naturalWidth, Number(source.getAttribute('width'))) || 1464;
    loadState.textContent = (document.documentElement.lang.toLowerCase().startsWith('fr') ? "Chargement de l’image…" : (document.documentElement.lang.toLowerCase().startsWith('it') ? "Caricamento dell’immagine…" : globalThis.fwExtraText("fw_extra.s_40ac20f3b65bcb", 'Bild wird geladen …')));
    loadState.hidden = false;
    enlarged.src = originalSource(source, originalLink);
    enlarged.alt = source.alt;
    if (enlarged.complete && enlarged.naturalWidth) loadState.hidden = true;
    // Browser-native modal behavior provides Escape, focus containment and inert background.
    dialog.showModal();
    document.documentElement.classList.add('fw-media-open');
    applyScale(2);
    frame.scrollTop = 0;
    frame.scrollLeft = 0;
    event.preventDefault();
  }

  function enhance(root = document) {
    root.querySelectorAll(artworkSelector).forEach(source => {
      if (source.dataset.fwMediaReady) return;
      source.dataset.fwMediaReady = 'true';
      const anchor = source.closest('a');
      // Do not repurpose an image that links to another product or page.
      const originalLink = anchor && /\.(?:avif|gif|jpe?g|png|webp)(?:[?#]|$)/i.test(anchor.href) ? anchor : null;
      const placement = source.closest('figure, .fw-story-poster') || anchor || source;
      const actions = document.createElement('div');
      actions.className = 'fw-media-actions';
      const link = document.createElement('a');
      link.className = 'fw-media-open-link';
      link.href = originalSource(source, originalLink);
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = (document.documentElement.lang.toLowerCase().startsWith('fr') ? "Agrandir l’image" : (document.documentElement.lang.toLowerCase().startsWith('it') ? "Ingrandisci l’immagine" : globalThis.fwExtraText("fw_extra.s_fd0d09a508c87c", 'Bild vergrößern')));
      actions.append(link);
      placement.before(actions);
      if (supportsDialog) {
        link.setAttribute('aria-haspopup', 'dialog');
        link.addEventListener('click', event => openArtwork(event, source, originalLink));
        if (originalLink) {
          originalLink.setAttribute('aria-haspopup', 'dialog');
          originalLink.addEventListener('click', event => openArtwork(event, source, originalLink));
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance(), { once: true });
  } else {
    enhance();
  }
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
